import { Grid, Stack, TextField } from '@hiiretail/react-foundation-ui';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { ReceiptFormData } from 'common/receipt.types';
import { Controller, useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';

export const ReceiptInformation = () => {
  const intl = useIntl();

  const {
    control,
    formState: { errors },
  } = useFormContext<ReceiptFormData>();

  return (
    <Grid item xs="auto">
      <Stack flexDirection="row" gap={3}>
        <Controller
          name="referencedFiscalNumber"
          control={control}
          rules={{
            required: intl.formatMessage({ id: 'receipt.input.required' }),
            pattern: {
              value: /^[._0-9a-zA-Z]+\/\d+$/,
              message: 'Invalid fiscal number format',
            },
          }}
          render={({ field }) => (
            <TextField
              label={intl.formatMessage({ id: 'receipt.referencedFiscalNumber' })}
              size="small"
              {...field}
              error={!!errors.referencedFiscalNumber}
              helperText={errors.referencedFiscalNumber?.message}
            />
          )}
        />
        <Controller
          name="invoiceDate"
          control={control}
          rules={{ required: intl.formatMessage({ id: 'receipt.input.required' }) }}
          render={({ field }) => (
            <DatePicker
              {...field}
              label={intl.formatMessage({ id: 'receipt.invoiceDate' })}
              renderInput={(params) => (
                <TextField {...params} size="small" error={!!errors.invoiceDate} />
              )}
            />
          )}
        />
      </Stack>
    </Grid>
  );
};
